module.exports = __webpack_public_path__ + "img/系统架构1.4577f633.png";